import { PasscodeLoginScreen } from '@/modules/passcode';
import React from 'react';

export default function PasscodeLoginRoute() {
    return <PasscodeLoginScreen />;
}

